import { GridColDef } from "@mui/x-data-grid";
//MPOGLU;447742;19022025

export interface TreeData {
  id: number;
  name: string;
}


export const initialData: TreeData[] = [
  {
    id: 1,
    name: "Beyin ve Sinir Cerrahisi"
  },
  {
    id: 2,
    name: "Alt Tedavi 1"
  },
  {
    id: 3,
    name: "Beyin ve Sinir Cerrahisi"
  },
  {
    id: 4,
    name: "Alt Tedavi 1"
  },
  {
    id: 5,
    name: "Beyin ve Sinir Cerrahisi"
  },
  {
    id: 6,
    name: "Alt Tedavi 1"
  },
];

export const treeViewData = [
    {
      id: 1,
      name: "Beyin ve Sinir Cerrahisi",
      children: [
        { id: 2, name: "Alt Tedavi 1" },
        { id: 3, name: "Alt Tedavi 2" },
      ],
    },
    {
      id: 4,
      name: "Kardiyoloji",
      children: [
        { id: 5, name: "Alt Tedavi 1" },
        { id: 6, name: "Alt Tedavi 2" },
      ],
    },
    {
      id: 7,
      name: "Ortopedi",
      children: [
        { id: 8, name: "Alt Tedavi 1" },
        { id: 9, name: "Alt Tedavi 2" },
      ],
    },
  ];

  export const treeViewData2 = [
    {
      id: 1,
      name: "Farklı Kullanıcı",
      children: [
        { id: 2, name: "Byz" },
        { id: 3, name: "Mcan" },
        { id: 4, name: "Aozmen" },
        { id: 5, name: "Yatay" },
      ],
    },
    {
      id: 6,
      name: "Kendim",
    },
    {
      id: 7,
      name: "Varsayılan Görünüm",
    },
  ];

export const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "Id",
    width: 250,
    headerClassName: "header-theme",
  },
  {
    field: "name",
    headerName: "Adı",
    width: 200,
    headerClassName: "header-theme",
  }
];

